<template>
    <b-modal
        ref="profile_modal"
        size="lg"
        bodyClass="p-0"
        v-bind:no-close-on-backdrop="true"
        :hide-header="true"
        v-model="is_show_modal"
        :dialogClass="dialog_class_draw"
    >
        <template v-slot:modal-header="{ close }">
            <b-button
                size="sm"
                variant="outline-danger"
                @click="close()"
            >
                Close Modal
            </b-button>
        </template>

        <div
            id="panel_users_list"
            class="panel mb-0 border-bottom-0 shadow-none"
        >
            <div
                class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0"
            >
                <h2>
                    <span class="fw-300">
                        ID: {{ location.id }}
                    </span>
                </h2>

                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button
                        class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed"
                        @click="close()"
                    >
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="p-2">
                <b-overlay
                    :show="is_load"
                    rounded="sm"
                >
                    <div
                        v-if="!is_load"
                        class="location_data"
                    >
                        <b-tabs
                            v-if="location.id > 0"
                            content-class="mt-3"
                        >
                            <b-tab
                                v-for="(tab, index) in draw_tabs"
                                :key="tab.index"
                                :title="get_tab_title(tab)"
                                @click="set_active(index)"
                            >
                                <template slot="title">
                                    <slot
                                        :location="location"
                                        :name="'title_' + tab.index"
                                    >
                                        <i
                                            v-if="tab.icon"
                                            :class="tab.icon"
                                            class="mr-1"
                                        ></i>

                                        {{ get_tab_title(tab) }}
                                    </slot>
                                </template>

                                <slot
                                    :location="location"
                                    :name="tab.index"
                                >
                                    <component
                                        :is="tab.index"
                                        :location="location"
                                        :provider_id="provider_id"
                                    ></component>
                                </slot>
                            </b-tab>
                        </b-tabs>

                        <slot
                            v-else
                            :location="location"
                            name="location_general_info"
                        >
                            <component
                                is="review_general_tab"
                                :location="location"
                            ></component>
                        </slot>
                    </div>
                </b-overlay>
            </div>
        </div>

        <template v-slot:modal-footer="{ close }">
            <div class="modal-footer">
                <button
                    type="button"
                    class="btn btn-secondary waves-effect waves-themed"
                    @click="close_modal"
                >
                    {{ __t("CLOSE") }}
                </button>

                <button
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                    @click="save_location"
                >
                    {{ __t("SAVE") }}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import review_general_tab from "./tabs/review_general_tab";
import review_google_tab from "./tabs/review_google_tab";

export default {
    name: "review_location_modal",

    props: {
        tabs_advanced: {
            type: Array,
            default() {
                return [];
            }
        }
    },

    components: {
        review_general_tab,
        review_google_tab
    },

    created() {
        EventBus.$on(
            "location_edit",
            this.work_click
        );

        try {
            if (this.tabs_advanced.length > 0) {
                this.tabs_advanced.map(tab => {
                    this.tabs.push(tab);
                });
            }
        } catch (e) {
        }
    },

    beforeDestroy() {
        EventBus.$off(
            "location_edit",
            this.work_click
        );
    },

    data() {
        return {
            tabs: [
                {
                    index: "review_general_tab",
                    title: this.__t("MAIN_SETTINGS"),
                    icon: "fal fa-cog"
                }
            ],

            modal_position: "left",

            is_show_modal: false,
            is_load: false,

            provider_id: 0,

            location: {
                id: 0,
                parent_id: 0,
                title: "",
                uniq_id: "",
                address: "",

                payment_id: 0,
                pay_cache: 0,
                shipping_id: 0,

                link_id: 0,
                source_id: 0
            },

            payments: [],

            worked_org: {
                title: ""
            }
        };
    },

    methods: {
        close_modal() {
            this.close();
        },

        close() {
            this.location = this.dfault_rest;
            this.provider_id = 0;
            this.is_show_modal = false;
        },

        get_tab_title(tab) {
            return tab.title;
        },

        set_active(obj) {
            EventBus.$emit(
                "update:tabu",
                {
                    type:
                    this.draw_tabs[obj].index,

                    user_id:
                    this.user_id
                }
            );
        },

        work_click(params) {
            let org_id = 0;
            let location_id = 0;
            let org_obj = null;

            if (
                params.hasOwnProperty("org_id")
            ) {
                org_id =
                    parseInt(params.org_id);
            }

            if (
                params.hasOwnProperty(
                    "location_id"
                )
            ) {
                location_id =
                    parseInt(
                        params.location_id
                    );
            }

            if (
                params.hasOwnProperty(
                    "org_obj"
                )
            ) {
                org_obj =
                    params.org_obj;
            }

            if (
                params.hasOwnProperty(
                    "provider_id"
                )
            ) {
                this.provider_id =
                    parseInt(
                        params.provider_id
                    );
            }

            this.is_show_modal = true;

            this.location.parent_id =
                org_id;

            if (org_obj !== null) {
                this.worked_org =
                    org_obj;

                if (
                    org_obj.hasOwnProperty(
                        "linked_childrens"
                    )
                ) {
                    this.location.linked_childrens =
                        org_obj.linked_childrens;
                }
            }

            this.load_location(
                location_id
            );
        },

        async load_location(_id) {
            this.is_load = true;

            let url =
                "/reviews/sources/" +
                this.provider_id +
                "/locations/0";

            if (_id > 0) {
                url =
                    "/reviews/locations/" +
                    _id;
            }

            await review_api
                .get(url)
                .then(({ data }) => {
                    if (
                        data.status ===
                        "operation_success"
                    ) {
                        if (
                            data.data !==
                            undefined &&
                            data.data.hasOwnProperty(
                                "id"
                            )
                        ) {
                            let cur_org =
                                this.location
                                    .parent_id;

                            this.location = {
                                ...this.location,
                                ...data.data
                            };

                            if (
                                cur_org > 0
                            ) {
                                this.location.parent_id =
                                    cur_org;
                            }
                        }
                    }

                    this.is_load = false;
                })
                .catch(({ response }) => {
                    this.is_load = false;

                    EventBus.$emit(
                        "show_toast",
                        {
                            err:
                            response.data
                                .message,

                            type:
                                "danger",

                            title:
                            response.data
                                .status
                        }
                    );
                });
        },

        async save_location() {
            this.is_load = true;

            let url =
                "/reviews/sources/" +
                this.provider_id +
                "/locations/" +
                this.location.id;

            if (
                this.location.id > 0
            ) {
                url =
                    "/reviews/locations/" +
                    this.location.id;
            }

            await review_api
                .put(
                    url,
                    {
                        store_item:
                        this.location
                    }
                )
                .then(({ data }) => {
                    if (
                        data.status ===
                        "operation_success"
                    ) {
                        EventBus.$emit(
                            "reload_locations"
                        );

                        this.close();
                    }

                    this.is_load = false;
                })
                .catch(({ response }) => {
                    this.is_load = false;

                    EventBus.$emit(
                        "show_toast",
                        {
                            err:
                            response.data
                                .message,

                            type:
                                "danger",

                            title:
                            response.data
                                .status
                        }
                    );
                });
        }
    },

    computed: {
        draw_tabs() {
            let tabs =
                JSON.parse(
                    JSON.stringify(
                        this.tabs
                    )
                );

            /*
             * Google provider = 60
             */
            if (
                parseInt(
                    this.provider_id
                ) === 60 &&
                this.location.id > 0
            ) {
                tabs.push({
                    index:
                        "review_google_tab",

                    title:
                        "Google",

                    icon:
                        "fab fa-google"
                });
            }

            return tabs;
        },

        dfault_rest() {
            return {
                id: 0,
                parent_id: 0,
                title: "",
                uniq_id: "",
                address: "",

                payment_id: 0,
                link_id: 0,
                shipping_id: 0,
                pay_cache: 0,

                children: []
            };
        },

        dialog_class_draw() {
            if (
                this.modal_position ===
                "left"
            ) {
                return (
                    "modal-dialog-left " +
                    "modal-lg"
                );
            }

            return (
                "modal-dialog-right " +
                "modal-lg"
            );
        }
    }
};
</script>

<style scoped>
</style>
